// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".type-resend[data-v-92df5bcc] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.font-weight-semibold[data-v-92df5bcc] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
